import { act, useEffect, useState } from "react";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";
import {
  getLeadEstimateLinkAction,
  setLeadEstimateDownloaded,
  setSingleLeadEstimateAction,
  setUpdateLeadAction,
  setUpdateLeadEstimateResponse,
} from "../../../../store/reducers/leadSlice";
import { useSelector } from "react-redux";
import ManageInvoice from "../../invoice/ManageInvoice";
import AlertMessage from "./AlertMessage";
import ManageDepositInvoice from "../../invoice/ManageDepositInvoice";
import SplitTemplateButton from "../SplitTemplateButton";
import {
  getAllEmailTemplatesAction,
  leadSendEmailTemplateAction,
} from "../../../../store/reducers/emailTemplateSlice";

const popupTitle: any = {
  email: "Lead Estimate Email",
  pdf: "Lead Estimate PDF",
  odt: "Lead Estimate ODT",
};

const popupTitleQuote: any = {
  email: "Lead Quote Email",
  pdf: "Lead Quote PDF",
  odt: "Lead Quote ODT",
  previous: "Lead Previous Quote",
};

const popupContent: any = {
  email: "Are you sure you want to send an email?",
  pdf: "Are you sure you want to download the PDF?",
  odt: "Are you sure you want to download the ODT?",
  previous: "Are you sure you want to download it?",
};

interface EstimateActionsPopupProps {
  estimateForm: any;
  deleteRec?: string;
  onHide?: () => void;
  setDeleteModalShow?: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  clientDetails?: any;
  setIsUpdated?: any;
  screenType?: any;
  isShowActionCalled?: any;
  setIsShowActionCalled?: any;
  disabledField?: any;
  setIsFieldValueChanged?: any;
  isFieldValueChanged?: any;
}

const EstimateActions: React.FC<EstimateActionsPopupProps> = ({
  estimateForm,
  screenType = "",
  isShowActionCalled,
  setIsShowActionCalled,
  disabledField,
  isFieldValueChanged,
  setIsFieldValueChanged,
}) => {
  const [open, setOpen] = useState(false);
  const [invoiceModel, setInvoiceModel] = useState(false);
  const [warningModelShow, setWarningModelShow] = useState(false);
  const [actionType, setActionType] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const {
    isFileDownloaded,
    isUpdateLeadSuccess,updateLeadEstimateResponse,
    isSingleEstimateResponseSuccess,
  } = useSelector((state: any) => state.lead);
  const { allEmailTemplates } = useSelector(
    (state: any) => state.emailTemplates,
  );
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { userProfile } = useSelector((state: any) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllEmailTemplatesAction({ lead_stage: "ESTIMATE" }));
  }, [dispatch]);

  useEffect(() => {
    if (isFileDownloaded) {
      dispatch(setLeadEstimateDownloaded(false));
      onHide();
    }
  }, [isFileDownloaded]);

  const onHide = () => {
    setOpen(false);
    setWarningModelShow(false);
    setActionType("");
  };

  const onShow = (type: any, templateParam?: any) => {
    setActionType(type);
    const finalTemplate = templateParam || selectedTemplate;
    const isQuotation = screenType === "quotation" && estimateForm?.quoteId;
    const isNotQuotation =
      screenType !== "quotation" && estimateForm?.estimateId;
    if (isFieldValueChanged && (isQuotation || isNotQuotation) && type) {
      setIsShowActionCalled(true);
    } else if (
      !isFieldValueChanged &&
      (isQuotation || isNotQuotation) &&
      type
    ) {
      if(type ==="email" && finalTemplate){
        handleSendEmailWithTemplate(finalTemplate)
      }else{
        submitHandler(type);
      }
    } else if (!isFieldValueChanged && !isQuotation && !isNotQuotation) {
      // setWarningModelShow(true);
      setIsShowActionCalled(true);
    } else if (isFieldValueChanged && !isQuotation && !isNotQuotation) {
      // setWarningModelShow(true);
      setIsShowActionCalled(true);
    }
  };

  const submitHandler = (typeParam?: string) => {
    const finalType = typeParam || actionType;
    dispatch(
      getLeadEstimateLinkAction({
        leadId: leadDetails?.lead?.generated_id,
        estimateId:
          screenType === "quotation"
            ? estimateForm?.quoteId
            : estimateForm?.estimateId,
        type: finalType,
        screenType,
      }),
    );
    setIsShowActionCalled(false);
    dispatch(setSingleLeadEstimateAction(false));
    setActionType("");
  };

  const handleClose = () => {
    setInvoiceModel(false);
  };
  const handleInvoice = () => {
    setInvoiceModel(true);
  };


  useEffect(() => {
    if (updateLeadEstimateResponse && actionType && estimateForm?.estimateId) {
       // if email template selected
    if (actionType === "email" && selectedTemplate) {
      handleSendEmailWithTemplate(selectedTemplate);
      setSelectedTemplate(null);
    } else {
      submitHandler();
    }
      dispatch(setUpdateLeadEstimateResponse(false));
      setIsShowActionCalled(false);
      dispatch(setUpdateLeadAction(false));
      dispatch(setSingleLeadEstimateAction(false));
      setActionType("");
    }
  }, [updateLeadEstimateResponse,estimateForm?.estimateId,isUpdateLeadSuccess]);

  console.log("estimateForm",estimateForm);
  const handleSendEmailWithTemplate = (template: any) => {
    dispatch(
      leadSendEmailTemplateAction({
        templateId: template?.template_id || "",
        leadId: leadDetails?.lead?.generated_id || "",
        estimateId: estimateForm?.estimateId || "",
        to: leadDetails?.lead?.email || "",
         template_from:template?.template_from,
        cc: [],
        bcc: [],
      }),
    );
  };

  

  return (
    <>
      {screenType === "quotation" && (
        <>
          {/* {invoiceModel && (
            <ManageInvoice
              title={"Invoice"}
              open={invoiceModel}
              onHide={handleClose}
              invoiceType="deposit"
              isSetLeadDetails={false}
              isNewInvoice={false}
            />
          )} */}
          {invoiceModel && (
            <ManageDepositInvoice
              title={"Deposit Invoice"}
              open={invoiceModel}
              onHide={handleClose}
              invoiceType="deposit"
              isSetLeadDetails={false}
              isNewInvoice={false}
              selectedQuote={estimateForm}
            />
          )}
          <CustomButton
            style={{ marginRight: "10px" }}
            title={screenType === "quotation" ? "Deposit" : "Deposit"}
            // disabled={estimateForm?.quoteId ? false : true}
            onClick={() => handleInvoice()}
          />
        </>
      )}
      {userProfile?.features?.includes("Professional Quotes") ? (
        <SplitTemplateButton
          title="Email"
          options={allEmailTemplates}
          disabled={disabledField}
          onButtonClick={(
            event?: React.MouseEvent<HTMLButtonElement, MouseEvent>
          ) => {
            // Only trigger if not the dropdown toggle
            if (event && event.nativeEvent instanceof PointerEvent) {
              // If the button is the dropdown (has aria-haspopup), do nothing
              if ((event.target as HTMLElement).getAttribute('aria-haspopup')) {
                return;
              }
            }
            // Find the default template (isDefault or is_primary for compatibility)
            let defaultTemplate = allEmailTemplates.find((tpl: any) => tpl.isDefault || tpl.is_primary);
            if (!defaultTemplate && allEmailTemplates && allEmailTemplates.length > 0) {
              // If no isDefault/is_primary, use the first template
              defaultTemplate = allEmailTemplates[0];
            }
            if (defaultTemplate) {
              setSelectedTemplate(defaultTemplate);
              onShow("email", defaultTemplate);
            }
          }}
          onSelect={(template: any) => {
            console.log("Selected Template:", template);
            setSelectedTemplate(template);
            onShow("email", template);
            // handleSendEmailWithTemplate(template);
          }}
        />
      ) : (
        <CustomButton
          disabled={disabledField}
          style={{ marginRight: "10px" }}
          title="Email"
          onClick={() => onShow("email")}
        />
      )}
      <CustomButton
        disabled={disabledField}
        style={{ marginRight: "10px" }}
        title="PDF"
        onClick={() => onShow("pdf")}
      />
      <CustomButton
        disabled={disabledField}
        style={{ marginRight: "10px" }}
        title="ODT"
        onClick={() => onShow("odt")}
      />
      {screenType === "quotation" && (
        <CustomButton
          disabled={
            screenType === "quotation"
              ? estimateForm?.quoteId && estimateForm?.count > 1
                ? false
                : true
              : estimateForm?.estimateId
                ? false
                : true
          }
          style={{ marginRight: "20px", marginTop: "5px", float: "right" }}
          title="Previous Quote"
          onClick={() => onShow("previous")}
        />
      )}
      <AlertPopup
        open={open}
        onHide={onHide}
        title={
          screenType === "quotation"
            ? popupTitleQuote[actionType]
            : popupTitle[actionType]
        }
        content={popupContent[actionType]}
        submitHandler={submitHandler}
      />
      {warningModelShow && (
        <AlertMessage
          open={warningModelShow}
          setAlertModelShow={setWarningModelShow}
          onHide={onHide}
          title={
            screenType === "quotation"
              ? popupTitleQuote[actionType]
              : popupTitle[actionType] ?? "Alert"
          }
          content={popupContent[actionType]}
        />
      )}
    </>
  );
};

export default EstimateActions;
